import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { ChevronsDoubleSVG } from '@common_components/svg/chevronsDouble.svg';

const ChevronsLeftIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size} rotate-180`} onClick={onClick}>
      <ChevronsDoubleSVG/>
    </div>
  );
};

export { ChevronsLeftIcon };
